import React, { useEffect, useState, useContext, Fragment } from "react";
import SharedDataContext from "../../_helper/SharedData";
import {
    getAllCarTypes,
    getCarTypes,
    getUserRole,
    showAlert,
} from "../../Services/Shared.service";
import { Breadcrumbs, Btn, CommonModal, H6 } from "../../AbstractElements";
import { Row, Col, Card, CardBody, Container, Modal, ModalBody, Nav, NavItem, NavLink } from "reactstrap";
import { Plus, RotateCw } from "react-feather";
import { getCarList, getCarListByFilter, getCarListBySearch } from "../../Services/Car.service";
import CarTable from "./CarTable";
import CreateCar from "./CreateCar";
import SearchTable from "../Common/Component/SearchTable";
import { useLocation } from "react-router";
import { Admin, OnboardingAgent } from "../../Data/SideMenu/RouteMapping";
import { carFilterColumns } from "../../Data/Driver/CarListing";
import FilterTable from "../Common/Component/FilterTable";
import SelectedFilter from "../TripManagement/BookingHistory/SelectedFilter";
import { getAggregators } from "../../Services/DispatchDashboard.service";
import { Button } from "@mui/material";
const Car = () => {
    const { cityData, globalCityField, setShowApiLoader, setPageNumber } =
        useContext(SharedDataContext);
    const [tableData, setTableData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [pagination, setPagination] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [paginationTotalRows, setPaginationTotalRows] = useState(0);
    const [createCarModal, setCreateCarModal] = useState(false);
    const toggleCreateCarModal = () =>
        setCreateCarModal(!createCarModal);
    const [editId, setEditId] = useState("")
    const [searchData, setSearchData] = useState("");
    const [filterType, setFilterType] = useState("");
    const [filterData, setFilterData] = useState([]);
    const [carTypeData, setCarTypeData] = useState([]);
    const [aggregatorList, setAggregatorList] = useState([]);
    const userRole = getUserRole()

    const location = useLocation()

    const onChangePage = (page) => {
        console.log("page", page);
        setPagination(page - 1);
    };

    const onChangeRowsPerPage = (currentRowsPerPage) => {
        setRowsPerPage(currentRowsPerPage);
    };

    useEffect(() => {
        fetchTableData();
    }, [globalCityField.value, pagination, rowsPerPage]);

    useEffect(() => {
        getCars()
        fetchAggregatorsList()
    }, []);

    const getCars = () => {
        let obj = {
            page: 0,
            size: 30
        };
        getAllCarTypes(obj)
            .then((result) => {
                const data = result?.data?.content.map((element) => {
                    return {
                        label: element.name,
                        value: element.id,
                    };
                });
                setCarTypeData(data);
            })
            .catch((err) => {
                showAlert("error", "Unable to fetch Car details for selected City");
            });
    }

    const fetchAggregatorsList = () => {
        getAggregators().then((result) => {
            if (result.data) {
                const data = result.data.map((element) => {
                    return {
                        label: element.companyName,
                        value: element.id,
                    };
                });
                setAggregatorList(data);
            }
        });
    }

    const fetchTableData = () => {
        const serviceCityId = globalCityField.value?.id || null;
        if (filterData.length == 0 && !searchData) {
            let obj = {
                serviceCityId: serviceCityId,
                page: pagination,
                size: rowsPerPage,
            };
            setLoader(true);
            getCarList(obj)
                .then((result) => {
                    setPaginationTotalRows(result.data.count);
                    setTableData(result.data.list);
                    disableLoaders();
                })
                .catch((err) => {
                    disableLoaders();
                    showAlert("error", err.response?.data?.message
                        ? err.response.data.message : "Something went wrong");
                });
        } else if (filterData.length > 0 && filterType == "filter") {
            let obj = {
                serviceCityId: serviceCityId,
                page: pagination,
                size: rowsPerPage,
            };
            filterData.forEach((d) => {
                obj[d.column_name] = d["values"][0]
            })
            setLoader(true);
            getCarListByFilter(obj)
                .then((result) => {
                    setPaginationTotalRows(result.data.count);
                    setTableData(result.data.searchResponse);
                    disableLoaders();
                })
                .catch((err) => {
                    disableLoaders();
                    showAlert("error", err.response?.data?.message
                        ? err.response.data.message : "Something went wrong");
                });
        } else if (searchData && filterType == "search") {
            let obj = {
                serviceCityId: serviceCityId,
                carNo: searchData,
                page: pagination,
                size: rowsPerPage,
            };
            setLoader(true);
            getCarListBySearch(obj)
                .then((result) => {
                    setPaginationTotalRows(result.data.count);
                    setTableData(result.data.list);
                    disableLoaders();
                })
                .catch((err) => {
                    disableLoaders();
                    showAlert("error", err.response?.data?.message
                        ? err.response.data.message : "Something went wrong");
                });
        }
    };
    const disableLoaders = () => {
        setLoader(false);
        // setShowApiLoader(false);
    };

    useEffect(() => {
        if (!searchData && filterType != "search") return;
        setPagination(0)
        fetchTableData();
    }, [searchData]);

    useEffect(() => {
        if (filterData.length == 0 && filterType != "filter") return;
        setPagination(0)
        fetchTableData();
    }, [filterData]);

    let columns = [];
    carFilterColumns.map((element) => {
        if (element.value) {
            columns.push({
                value: {
                    name: element.name,
                    value: element.value,
                    type: element.type,
                },
                label: element.name,
            });
        }
    });

    const removeFilter = (index) => {
        const newfilterData = [...filterData];
        newfilterData.splice(index, 1);
        setFilterData(newfilterData);
    };

    const procurementStatusApi = (procurementStatus) => {
      const serviceCityId = globalCityField.value?.id || null;
  
      let obj = {
        serviceCityId: serviceCityId,
        procurementStatus: procurementStatus,
        page: pagination,
        size: rowsPerPage,
      };
  
      setLoader(true);
      getCarListByFilter(obj)
        .then((result) => {
          setPaginationTotalRows(result.data.count);
          setTableData(result.data.searchResponse);
          disableLoaders();
        })
        .catch((err) => {
          disableLoaders();
          showAlert(
            "error",
            err.response?.data?.message
              ? err.response.data.message
              : "Something went wrong"
          );
        });
    };

    return (
        <Fragment>
            <Breadcrumbs
                parent="Configuration"
                subParent="Inventory"
                mainTitle="Cabs"
                span3={
                    <SearchTable
                        searchData={searchData}
                        setSearchData={setSearchData}
                        setFilterData={setFilterData}
                        setFilterType={setFilterType}
                    />
                }
                span4={
                  userRole.some(
                    (element) => element == Admin || element == OnboardingAgent
                  ) ? (
                    <Button
                      sx={{
                        display: "flex",
                        padding: "5px 20px",
                        margin: "0 3px",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#000",
                        backgroundColor: "#eaeaea",
                      }}
                      onClick={() => procurementStatusApi("onRoad")}
                    >
                      ON ROAD
                    </Button>
                  ) : null
                }
                span5={
                  userRole.some(
                    (element) => element == Admin || element == OnboardingAgent
                  ) ? (
                    <Button
                      sx={{
                        display: "flex",
                        padding: "5px 20px",
                        margin: "0 3px",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#000",
                        backgroundColor: "#eaeaea",
                      }}
                      onClick={() => procurementStatusApi("offRoad")}
                    >
                      OFF ROAD
                    </Button>
                  ) : null
                }
                span6={
                  userRole.some(
                    (element) => element == Admin || element == OnboardingAgent
                  ) ? (
                    <Btn
                      attrBtn={{
                        style: {
                          display: "flex",
                          padding: "5px 10px",
                          margin: "0 3px",
                          justifyContent: "center",
                          alignItems: "center",
                        },
                        onClick: fetchTableData,
                      }}
                    >
                      <RotateCw size={"20px"} />
                    </Btn>
                  ) : null
                }
                span1={
                    userRole.some(
                        (element) => element == Admin || element == OnboardingAgent
                    ) ? <Btn attrBtn={{ style: { display: "flex", padding: "7px 14px", justifyContent: "center", alignItems: "center" }, onClick: toggleCreateCarModal }}>
                        <Plus size={"18px"} style={{ marginRight: "5px" }} /> Add
                    </Btn> : null
                }
                span2={
                    <FilterTable
                        options={columns}
                        setFilterData={setFilterData}
                        filterData={filterData}
                        setSearchData={setSearchData}
                        setFilterType={setFilterType}
                        statusData={[
                            { value: "offRoad", label: "offRoad" },
                            { value: "onRoad", label: "onRoad" }
                        ]}
                        carTypeData={carTypeData}
                        aggregatorData={aggregatorList}
                    />
                }
            />
            <Container fluid={true} className="datatables">
                <Row className="selected-filter">
                    {filterData.map((element, i) => {
                        return (
                            <SelectedFilter
                                key={i}
                                element={element}
                                index={i}
                                removeFilter={removeFilter}
                            />
                        );
                    })}
                </Row>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody className="p-0">
                                <CarTable
                                    fetchTableData={fetchTableData}
                                    tableData={tableData}
                                    setShowApiLoader={setLoader}
                                    onChangePage={onChangePage}
                                    paginationPerPage={rowsPerPage}
                                    paginationTotalRows={paginationTotalRows}
                                    onChangeRowsPerPage={onChangeRowsPerPage}
                                    pagination={pagination}
                                    setPageNumber={setPageNumber}
                                    pageNumber={
                                        location.state?.pageNumber
                                            ? location.state.pageNumber + 1
                                            : 1
                                    }
                                    filterData={filterData}
                                    searchData={searchData}
                                    loader={loader}
                                    setEditId={setEditId}
                                    toggleCreateCarModal={toggleCreateCarModal}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <CreateCar
                Large={createCarModal}
                title={editId ? "Update Car" : "Create Car"}
                LargeModaltoggle={() => {
                    setEditId("")
                    fetchTableData()
                    toggleCreateCarModal()
                }}
                cityDataList={cityData}
                setShowApiLoader={setShowApiLoader}
                editId={editId}
            />
        </Fragment>
    );
};

export default Car;
